import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=5ee629f3&"
import script from "./ProductsItem.vue?vue&type=script&lang=js&"
export * from "./ProductsItem.vue?vue&type=script&lang=js&"
import style0 from "./products-item.scss?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports